<!-- 树状选择器 -->
<template>
  <div>
  <el-popover
    ref="popover"
    :disabled="disabled"
    v-if="props"
    placement="bottom-start"
    trigger="click"
    @show="onShowPopover"
    @hide="onHidePopover"
  >
    <el-tree
      ref="tree"
      class="form-select-tree"
      :style="`min-width: ${treeWidth};`"
      :data="data"
      :props="props"
      :expand-on-click-node="false"
      :filter-node-method="filterNode"
      :default-expand-all="false"
      @node-click="onClickNode"
    >
    </el-tree>
    <el-input
      slot="reference"
      ref="input"
      :size="size"
      :disabled="disabled"
      v-model="labelModel"
      :clearable = "clearable"
      @focus="focus"
      @clear= 'clearValue'
      @input='treeSearch'
      :style="`width: ${width}px;`"
      :class="{ rotate: showStatus }"
      :placeholder="placeholder"
    >
    <i slot="suffix" class="el-icon-arrow-down" v-if="!labelModel" />
    </el-input>
  </el-popover>
  </div>
</template>

<script>
export default {
  name: 'form_select_tree',
  props: {
    // 接收绑定参数
    value: String,
    // 输入框宽度
    width: String,
    // 组件size
    size: String,
    filterable: {
      type: Boolean,
      default: false,
    },
    // 选项数据
    options: {
      type: Array,
      default() {
        return [];
      },
    },
    // 输入框占位符
    placeholder: {
      type: String,
      required: false,
      default: '请选择',
    },
    // 树节点配置选项
    props: {
      type: Object,
    },
    disabled: {
      type: Boolean,
      default() {
        return false;
      },
    },
    clearable: {
      type: Boolean,
      default() {
        return true;
      },
    },
  },
  // 设置绑定参数
  // model: {
  //   prop: 'value',
  //   event: 'selected',
  // },
  computed: {
    // 是否为树状结构数据
    dataType() {
      const jsonStr = JSON.stringify(this.options);
      return jsonStr.indexOf(this.props.children) !== -1;
    },
    // 若非树状结构，则转化为树状结构数据
    data() {
      const treeOptions = this.options;
      return treeOptions;
    },
  },
  watch: {
    props(val) {
      console.log('props', val);
    },
    value(val) {
      this.labelModel = this.queryTree(this.data, val);
      this.valueModel = val;
    },
    options() {
      this.labelModel = this.queryTree(this.data, this.value);
    },
  },
  data() {
    return {
      // 树状菜单显示状态
      showStatus: false,
      // 菜单宽度
      treeWidth: 'auto',
      // 输入框显示值
      labelModel: '',
      // 实际请求传值
      valueModel: '',
      treeProps: {},
    };
  },
  created() {
    // 检测输入框原有值并显示对应 label
    if (this.value) {
      this.labelModel = this.queryTree(this.data, this.value);
    }
  },
  mounted() {
    // 获取输入框宽度同步至树状菜单宽度
  },
  methods: {
    // focus事件
    focus() {
      this.$emit('focus');
    },
    // 单击节点
    onClickNode(node) {
      this.labelModel = node[this.props.label];
      this.valueModel = node[this.props.value];
      this.$emit('input', this.valueModel);
      this.$emit('change', this.valueModel);
      this.$emit('getLabel', this.labelModel);
      this.onCloseTree();
    },
    // 偏平数组转化为树状层级结构
    switchTree() {
      return this.cleanChildren(this.buildTree(this.options, '0'));
    },
    // 隐藏树状菜单
    onCloseTree() {
      this.$refs.popover.showPopper = false;
    },
    // 显示时触发
    onShowPopover() {
      if (!this.disabled) {
        this.$nextTick(() => {
          this.treeWidth = `${(this.width || this.$refs.input.$refs.input.clientWidth) - 24}px`;
        });
        this.showStatus = true;
        this.$refs.tree.filter(false);
      }
    },
    // 隐藏时触发
    onHidePopover() {
      this.showStatus = false;
      console.log(this.labelModel, this.valueModel);
      if (this.labelModel === '' || this.valueModel === '') {
        this.valueModel = '';
        this.labelModel = '';
      }
    },
    // 清空
    clearValue() {
      this.valueModel = '';
      this.labelModel = '';
      this.$emit('input', this.valueModel);
      this.onCloseTree();
    },
    // 树节点过滤方法
    filterNode(query, data) {
      if (!query) return true;
      return data[this.props.label].indexOf(query) !== -1;
    },
    // 搜索树状数据中的 ID
    queryTree(tree, id) {
      let stark = [];
      stark = stark.concat(tree);
      while (stark.length) {
        const temp = stark.shift();
        if (temp[this.props.children]) {
          stark = stark.concat(temp[this.props.children]);
        }
        if (temp[this.props.value] === id) {
          return temp[this.props.label];
        }
      }
      return id;
    },
    treeSearch(val) {
      this.$refs.tree.filter(val);
    },
    // 将一维的扁平数组转换为多层级对象
    buildTree(data, id = '0') {
      const fa = (parentId) => {
        const temp = [];
        data.forEach((item, i) => {
          const n = data[i];
          if (n[this.props.parent] === parentId) {
            n.children = fa(n.rowGuid);
            temp.push(n);
          }
        });
        return temp;
      };
      return fa(id);
    },
    // 清除空 children项
    cleanChildren(data) {
      const fa = (list) => {
        list.map((e) => {
          if (e.children.length) {
            fa(e.children);
          } else {
            delete e.children;
          }
          return e;
        });
        return list;
      };
      return fa(data);
    },
  },
};
</script>

<style lang="less" scoped>
/deep/.el-input.el-input--suffix {
  overflow: hidden;
  cursor: pointer;
  &:focus {
    outline: none;
  }
}
/deep/.el-input__inner {
  cursor: pointer;
}
/deep/.el-tree-node__label{
  font-size: 12px;
}
/deep/.el-input.el-input--suffix.rotate .el-input__suffix {
  transform: rotate(180deg);
}
// /deep/ .el-tree {
//   max-height: 300px !important;
//   overflow-y: scroll;
//   overflow-x: hidden;
// }
/deep/.el-tree--highlight-current{
  height: 200px !important;
  overflow-y: scroll;
}
/deep/.select-tree {
  height: 200px !important;
  overflow-y: scroll;
}
/* 菜单滚动条 */
/deep/.select-tree::-webkit-scrollbar {
  z-index: 11;
  width: 6px;
}
/deep/.select-tree::-webkit-scrollbar-track,
/deep/.select-tree::-webkit-scrollbar-corner {
  background: #fff;
}
/deep/.select-tree::-webkit-scrollbar-thumb {
  border-radius: 5px;
  width: 6px;
  background: #b4bccc;
}
/deep/.select-tree::-webkit-scrollbar-track-piece {
  background: #fff;
  width: 6px;
}
</style>
